import { videos } from '@/mocks/videos';
import { useNavigate } from 'react-router-dom';

export default function FeaturedSection() {
  const navigate = useNavigate();
  const featuredVideos = videos.filter((v) => v.featured);

  const handleClick = (id: string) => {
    navigate(`/article/${id}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1920px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            精选推荐
          </h2>
          <p className="mt-1 text-sm text-foreground-500">编辑精选，必看好片</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {featuredVideos.map((video) => (
            <div
              key={video.id}
              className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden border border-background-200/70"
              onClick={() => handleClick(video.id)}
              data-product-shop=""
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.image}
                  alt={video.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 bg-black/70 backdrop-blur-sm text-white text-xs font-label rounded-md">
                    {video.duration}
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 bg-accent-500 text-background-50 text-xs font-bold font-label rounded-md flex items-center gap-1">
                    <i className="ri-star-fill text-[10px]"></i>
                    {video.rating}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors text-base line-clamp-1">
                  {video.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {video.description}
                </p>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  {video.tags.map((tag) => (
                    <span key={tag} className="text-[10px] text-foreground-500 bg-secondary-100 px-2 py-0.5 rounded">
                      {tag}
                    </span>
                  ))}
                  <span className="text-xs text-foreground-400 ml-auto">{video.updateTime}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}